import { CustomMultiSelect } from '../../common/CustomMultiSelect';

export default function LeadExportFilterControl({
  filterName,
  countries,
  activeAgents,
  exportCountries,
  setExportCountries,
  exportAgents,
  setExportAgents,
  exportStatus,
  setExportStatus,
  exportVisaCategory,
  setExportVisaCategory,
  visaTypeFilters,
  exportMatchField,
  setExportMatchField,
  selectedExportReport,
  exportDays,
  setExportDays,
  exportBiometricFromDate,
  handleExportBiometricFromDateChange,
  exportBiometricToDate,
  handleExportBiometricToDateChange,
  statusFilters,
}) {
  switch (filterName) {
    case 'countries':
      return (
        <CustomMultiSelect
          options={(countries || [])
            .map((country) => {
              const countryValue =
                typeof country === 'string'
                  ? country
                  : country?.title ||
                    country?.name ||
                    country?.value ||
                    country?.label ||
                    '';

              return {
                label: countryValue,
                value: countryValue,
              };
            })
            .filter((option) => option.value)}
          value={exportCountries}
          onChange={(values) => setExportCountries(values)}
          placeholder="Select"
          showSelectAll={true}
          selectAllLabel="Select All Countries"
        />
      );
    case 'agents':
      return (
        <CustomMultiSelect
          options={activeAgents.map((agent) => ({
            label: `${agent.firstName || ''} ${agent.lastName || ''}`.trim(),
            value: agent._id,
          }))}
          value={exportAgents}
          onChange={(values) => setExportAgents(values)}
          placeholder="Select"
        />
      );
    case 'status':
      return (
        <select
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#005787]"
          value={exportStatus}
          onChange={(e) => setExportStatus(e.target.value)}
        >
          <option value="" disabled>
            Status
          </option>
          {statusFilters.map((status) => {
            if (status === 'All' || status === 'all') return null;
            return (
              <option key={status} value={status}>
                {status}
              </option>
            );
          })}
        </select>
      );
    case 'visaCategory':
      return (
        <select
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#005787]"
          value={exportVisaCategory}
          onChange={(e) => setExportVisaCategory(e.target.value)}
        >
          <option value="">Visa Category</option>
          {visaTypeFilters.map((category) => (
            <option key={category?._id} value={category?.title}>
              {category?.title}
            </option>
          ))}
        </select>
      );
    case 'matchField':
      return (
        <select
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#005787]"
          value={exportMatchField}
          onChange={(e) => setExportMatchField(e.target.value)}
        >
          {selectedExportReport?.matchFieldOptions?.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      );
    case 'days':
      return (
        <input
          type="number"
          min="1"
          inputMode="numeric"
          pattern="[0-9]*"
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#005787] [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          value={exportDays}
          onChange={(e) => setExportDays(e.target.value.replace(/\D/g, ''))}
        />
      );
    case 'biometricFromDate':
      return (
        <input
          type="date"
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#005787]"
          value={exportBiometricFromDate}
          onChange={(e) => handleExportBiometricFromDateChange(e.target.value)}
        />
      );
    case 'biometricToDate':
      return (
        <input
          type="date"
          min={exportBiometricFromDate || undefined}
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#005787]"
          value={exportBiometricToDate}
          onChange={(e) => handleExportBiometricToDateChange(e.target.value)}
        />
      );
    default:
      return null;
  }
}
